import { z } from "zod/v4";
import { MAP_NOTE_PIN_MARKERS } from "../types/mapNotePin.js";
// `color` is the legacy field name; the union now spans both the original
// colored pins and the newer banner markers (see MapNotePinColor).
const mapNoteColorSchema = z.enum(MAP_NOTE_PIN_MARKERS);
export const createMapNoteInputSchema = z.object({
    q: z.number().int(),
    r: z.number().int(),
    name: z.string().optional().default(""),
    color: mapNoteColorSchema.optional(),
    hidden: z.boolean().optional(),
    offsetX: z.number().finite().optional(),
    offsetY: z.number().finite().optional(),
    templateId: z.string().min(1).optional(),
});
export const updateMapNoteInputSchema = z.object({
    name: z.string().optional(),
    visibleToPlayers: z.boolean().optional(),
    hidden: z.boolean().optional(),
    color: mapNoteColorSchema.optional(),
    offsetX: z.number().finite().optional(),
    offsetY: z.number().finite().optional(),
    q: z.number().int().optional(),
    r: z.number().int().optional(),
});
